import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ENTITIES } from '../constants/entities';

function DashboardStats({ role, filiale }) {
  const [stats, setStats] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState('');

  // ✅ Vérifie si l'utilisateur est un admin global (admin ou ceo)
  const isGlobalAdmin = ['admin', 'ceo'].includes(role);

  // 🔁 Récupère les statistiques depuis le backend au chargement du composant
  useEffect(() => {
    const fetchStats = async () => {
      try {
        // ✅ Vérifie si l'utilisateur est un manager
        const isManager = role === 'manager';

        // 👇 Choix de l'URL selon le rôle
        const url = isManager
          ? `${process.env.REACT_APP_DOMAINE}/api/stats/filiale/${filiale}` // stats de la filiale
          : `${process.env.REACT_APP_DOMAINE}/api/stats/global`; // stats globales

        const res = await axios.get(url);
        setStats(res.data);
      } catch (err) {
        console.error("Erreur récupération stats :", err.message);
      }
    };

    fetchStats();
  }, [role, filiale]);

  // 🕐 Affiche un message tant que les données ne sont pas prêtes
  if (!stats) return <p>Chargement des statistiques...</p>;

  return (
    <div className="mt-4">
      <h4>📊 Statistiques</h4>

      {/* ✅ Bloc des totaux (visible pour tous) */}
      <div className="row">
        <div className="col-md-4">
          <div className="card text-bg-light mb-3 p-3">
            <h5>Total des candidats</h5>
            <p className="display-6">{stats.total_candidates}</p>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card text-bg-light mb-3 p-3">
            <h5>Total des offres</h5>
            <p className="display-6">{stats.total_jobs}</p>
          </div>
        </div>
      </div>

      {/* 👑 Section uniquement visible pour les admins globaux */}
      {isGlobalAdmin && (
        <>
          <h5 className="mt-4">👥 Candidats par Entité</h5>
          <ul className="list-group mb-4">
            {ENTITIES.map((entity) => {
              const entityData = stats.candidates_by_filiale?.find((f) => f.filiale === entity);
              const count = entityData ? entityData.count : 0;
              return (
                <li className="list-group-item d-flex justify-content-between" key={entity} style={{ backgroundColor: '#fff', color: '#000' }}>
                  <strong>{entity}</strong>
                  <span>{count}</span>
                </li>
              );
            })}
          </ul>
        </>
      )}

    </div>
  );
}

export default DashboardStats;
